import { IRIS_GLOBAL_FOOTER_NAVIGATION_GET_REQUEST } from '../actionTypes/FooterNavigationActionTypes';

const getIrisFooterGlobalNavigationAction = () => ({
    type: IRIS_GLOBAL_FOOTER_NAVIGATION_GET_REQUEST,
});

export default {
    getIrisFooterGlobalNavigationAction,
};
